import { apiFetch } from "./client";
import type {
  ActivityFilterParams,
  ActivityListResponse,
  ByFileResponse,
  ByUserResponse,
  OverviewResponse,
  TimeseriesParams,
  TimeseriesResponse,
} from "./types";

/** Build a query string from filter params, omitting empty values. */
function queryString(params: ActivityFilterParams): string {
  const q = new URLSearchParams();
  if (params.userId) q.set("userId", params.userId);
  if (params.action) q.set("action", params.action);
  if (params.from) q.set("from", params.from);
  if (params.to) q.set("to", params.to);
  if (params.page) q.set("page", String(params.page));
  if (params.pageSize) q.set("pageSize", String(params.pageSize));
  const s = q.toString();
  return s ? `?${s}` : "";
}

export function getOverview(): Promise<OverviewResponse> {
  return apiFetch<OverviewResponse>("/api/activity/overview");
}

export function getActivity(params: ActivityFilterParams): Promise<ActivityListResponse> {
  return apiFetch<ActivityListResponse>(`/api/activity${queryString(params)}`);
}

export function getActivityByUser(userId: string): Promise<ByUserResponse> {
  return apiFetch<ByUserResponse>(`/api/activity/by-user/${userId}`);
}

export function getActivityByFile(fileId: string): Promise<ByFileResponse> {
  return apiFetch<ByFileResponse>(`/api/activity/by-file/${fileId}`);
}

export function getTimeseries(params: TimeseriesParams): Promise<TimeseriesResponse> {
  const q = new URLSearchParams();
  if (params.from) q.set("from", params.from);
  if (params.to) q.set("to", params.to);
  if (params.granularity) q.set("granularity", params.granularity);
  if (params.cumulative !== undefined) q.set("cumulative", String(params.cumulative));
  const s = q.toString();
  return apiFetch<TimeseriesResponse>(`/api/activity/timeseries${s ? `?${s}` : ""}`);
}

/** Same-origin CSV export href (cookie-authed). Drop it into an <a download>. */
export function exportCsvHref(params: ActivityFilterParams): string {
  // page/pageSize are irrelevant to the export — strip them.
  const { page: _p, pageSize: _ps, ...rest } = params;
  return `/api/activity/export.csv${queryString(rest)}`;
}
